import React, { useState, useEffect } from 'react';
import API from '../utils/api';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const COP = n => new Intl.NumberFormat('es-CO', { style:'currency', currency:'COP', maximumFractionDigits:0 }).format(Number(n)||0);

export default function Colillas() {
  const [colillas, setColillas] = useState([]);
  const [seleccionada, setSeleccionada] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    API.get('/app/mis-colillas')
      .then(r => { setColillas(r.data); setCargando(false); })
      .catch(() => setCargando(false));
  }, []);

  if (cargando) return <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>Cargando pagos...</div>;

  if (colillas.length === 0) return (
    <div style={{ textAlign:'center', padding:'60px 20px', color:'#9CA3AF' }}>
      <div style={{ fontSize:48, marginBottom:12 }}>💵</div>
      <div style={{ fontWeight:600 }}>Sin pagos registrados</div>
      <div style={{ fontSize:13, marginTop:4 }}>Tus colillas de pago aparecerán aquí</div>
    </div>
  );

  if (seleccionada) {
    const c = seleccionada;
    const fmtFecha = d => d ? format(new Date(d+'T12:00'), "d 'de' MMMM yyyy", { locale: es }) : '—';
    return (
      <div>
        <button onClick={() => setSeleccionada(null)}
          style={{ background:'none', border:'none', color:'#2563EB', fontSize:14, cursor:'pointer', fontWeight:600, marginBottom:16, padding:0 }}>
          ← Volver
        </button>

        <div style={{ background:'#1a1a2e', borderRadius:16, padding:20, marginBottom:16, color:'white' }}>
          <div style={{ fontSize:12, opacity:0.6, marginBottom:4 }}>Período de pago</div>
          <div style={{ fontWeight:700, fontSize:16 }}>{fmtFecha(c.fecha_inicio)} – {fmtFecha(c.fecha_fin)}</div>
          <div style={{ marginTop:12, fontSize:11, opacity:0.5 }}>{c.empleado_nombre} · {c.bodega_nombre}</div>
        </div>

        {/* Devengados */}
        <div style={{ background:'white', borderRadius:14, padding:16, marginBottom:10, boxShadow:'0 1px 3px rgba(0,0,0,0.07)' }}>
          <div style={{ fontWeight:700, color:'#059669', marginBottom:12, fontSize:14 }}>✅ Devengados</div>
          {[
            ['Salario base', c.salario_base],
            ['Horas extra', c.valor_horas_extra],
            ['Aux. transporte', c.aux_transporte],
            ['Comisiones', c.comisiones],
            ['Bonificaciones', c.bonificaciones],
          ].filter(([,v]) => v > 0).map(([k,v]) => (
            <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #F3F4F6', fontSize:13 }}>
              <span style={{ color:'#374151' }}>{k}</span>
              <span style={{ fontWeight:600 }}>{COP(v)}</span>
            </div>
          ))}
          <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0 0', fontSize:14, fontWeight:800 }}>
            <span>Total devengado</span>
            <span style={{ color:'#059669' }}>{COP(c.total_devengado)}</span>
          </div>
        </div>

        {/* Deducciones */}
        <div style={{ background:'white', borderRadius:14, padding:16, marginBottom:10, boxShadow:'0 1px 3px rgba(0,0,0,0.07)' }}>
          <div style={{ fontWeight:700, color:'#EF4444', marginBottom:12, fontSize:14 }}>➖ Deducciones</div>
          {[
            ['Salud (4%)', c.descuento_salud],
            ['Pensión (4%)', c.descuento_pension],
            ['Ausencias', c.descuento_ausencias],
            ['Anticipos', c.descuento_anticipos],
            ['Otros', c.otras_deducciones],
          ].filter(([,v]) => v > 0).map(([k,v]) => (
            <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #F3F4F6', fontSize:13 }}>
              <span style={{ color:'#374151' }}>{k}</span>
              <span style={{ fontWeight:600, color:'#EF4444' }}>- {COP(v)}</span>
            </div>
          ))}
          <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0 0', fontSize:14, fontWeight:800 }}>
            <span>Total deducciones</span>
            <span style={{ color:'#EF4444' }}>- {COP(c.total_deducciones)}</span>
          </div>
        </div>

        {/* Neto */}
        <div style={{ background:'#059669', borderRadius:14, padding:18, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ color:'white', fontWeight:700, fontSize:16 }}>💵 Neto a pagar</span>
          <span style={{ color:'white', fontWeight:800, fontSize:22 }}>{COP(c.neto_pagar)}</span>
        </div>

        {c.notas && (
          <div style={{ background:'#FEF3C7', borderRadius:10, padding:'10px 14px', marginTop:10, fontSize:13, color:'#92400E' }}>
            📝 {c.notas}
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ margin:'0 0 16px', fontSize:20, fontWeight:800, color:'#111827' }}>💵 Mis pagos</h1>
      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {colillas.map(c => (
          <div key={c.id} onClick={() => setSeleccionada(c)}
            style={{ background:'white', borderRadius:14, padding:'14px 16px', boxShadow:'0 1px 3px rgba(0,0,0,0.07)', cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div>
              <div style={{ fontWeight:700, fontSize:14, color:'#111827' }}>
                {c.fecha_inicio ? format(new Date(c.fecha_inicio+'T12:00'), "d MMM", { locale: es }) : '—'}
                {' – '}
                {c.fecha_fin ? format(new Date(c.fecha_fin+'T12:00'), "d MMM yyyy", { locale: es }) : '—'}
              </div>
              <div style={{ fontSize:12, color:'#6B7280', marginTop:2 }}>{c.tipo_periodo || 'Quincenal'}</div>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontWeight:800, fontSize:16, color:'#059669' }}>{COP(c.neto_pagar)}</div>
              <div style={{ fontSize:11, color:'#9CA3AF', marginTop:2 }}>Ver colilla →</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
